// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import Anchor from '../../../../../atoms/Anchor';
import withStyles from '../../../../../hoc/withStyles';
import styles from '../styles/BonusPointsReadSection.style';
import BodyCopy from '../../../../../atoms/BodyCopy/views/BodyCopy';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblDetails,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import BonusPointsDaysLabels, { GLOBAL_LABELS } from '../../../labels/BonusPointsDays.labels';

export const BonusPointsReadSection = ({
  toggleBonusPointsModal,
  availableBonusPointDays,
  usedBonusPointDays,
  className,
}) => {
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, BonusPointsDaysLabels);
  const { placeRewards } = globalLabels;
  if (availableBonusPointDays === null) {
    return null;
  }
  const availableDaysArray =
    availableBonusPointDays > 0 ? Array(availableBonusPointDays).fill('') : [];
  const usedDaysArray = usedBonusPointDays > 0 ? Array(usedBonusPointDays).fill('') : [];
  const message = renderLabel(
    placeRewards?.lbl_bonus_points_daysLeft,
    'lbl_bonus_points_daysLeft'
  ).replace(/\{0\}/, availableBonusPointDays);

  return (
    <BodyCopy component="div" className={`${className} elem-pt-LRG`}>
      <BodyCopy component="div" className="bonusPointDayHeading elem-mb-XS">
        <BodyCopy
          fontSize="fs14"
          fontWeight="semibold"
          data-locator="accountoverview-myplacerewatdstile-bonuspointdaytext"
        >
          {renderLabel(
            placeRewards?.lbl_bonus_points_bonusPointsDay,
            'lbl_bonus_points_bonusPointsDay'
          )}
        </BodyCopy>
        <Anchor
          anchorVariation="primary"
          fontSizeVariation="large"
          underline
          onClick={toggleBonusPointsModal}
          dataLocator="accountoverview-myplacerewatdstile-bonuspointdetaillink"
        >
          {renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
              GlobalGenericLabels
            ),
            'lbl_details'
          )}
        </Anchor>
      </BodyCopy>
      <BodyCopy fontSize="fs14" component="div">
        {message}
        {usedDaysArray.map(() => (
          <span
            className="dot filled elem-ml-XS"
            data-locator="accountoverview-myplacerewatdstile-bonuspointdots"
          />
        ))}
        {availableDaysArray.map(() => (
          <span
            className="dot elem-ml-XS"
            data-locator="accountoverview-myplacerewatdstile-bonuspointdots"
          />
        ))}
      </BodyCopy>
    </BodyCopy>
  );
};

BonusPointsReadSection.propTypes = {
  availableBonusPointDays: PropTypes.number.isRequired,
  usedBonusPointDays: PropTypes.number.isRequired,
  toggleBonusPointsModal: PropTypes.func.isRequired,
  className: PropTypes.string,
};

BonusPointsReadSection.defaultProps = {
  className: '',
};

export default withStyles(BonusPointsReadSection, styles);
